// extracted by mini-css-extract-plugin
export default {"wrapper":"Progressbar_wrapper__ZhMy1","circle":"Progressbar_circle__v4I22","inner":"Progressbar_inner__GaD03"};